export const getFormData = (
  data: Array<{ field: string; value: File | string }>,
) => {
  const formData = new FormData();

  data.forEach(({ field, value }) => formData.append(field, value));

  return formData;
};
